<template>
  <el-table
    v-loading="loading"
    :data="data"
    border
    stripe
  >
    <el-table-column
      v-for="{ type, ...column } in columnList"
      :key="type"
      :prop="type"
      :label="column.title || $t(`table.${type}`)"
      v-bind="column.custom"
    >
      <template #default="{ row }">
        <slot
          :row="row"
          :type="type"
          :data="row[type]"
          name="columns"
        >
          <div>
            {{ row[type] }}
          </div>
        </slot>
      </template>
    </el-table-column>

    <slot name="action-column" />
  </el-table>
</template>

<script>
import { createComponent } from '@vue/composition-api'

export default createComponent({
  name: 'CustomTable',
  props: {
    /**
     * Whether to show loading spinner at the middle of table
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * List of data row
     */
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * Descriptive list of objects of each column
     * [
     *   {
     *      type: '',       // attribute key of data
     *      title: '',      // (optional) column name, which default is $t(`table.${type}`)
     *   `  custom: { },    // (optional) any props for <el-table-column>
     *   },
     * ]
     */
    columnList: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
    }
  },
})
</script>
